export default __webpack_public_path__ + "static/media/succulent2.8489a344.jpg";